import { includes } from "lodash";
import { Facet } from "@linkfluence/models/facet";

export const isReviewFacet = (facet: Facet) => {
  return includes([Facet.Product, Facet.ProductRange, Facet.Franchise], facet);
};

export const getProductFromFacet = (facet: Facet) => {
  if (facet === Facet.Product) return "eans";
  if (facet === Facet.ProductRange) return "product-ranges";
  if (facet === Facet.Franchise) return "franchises";
  return null;
};
